export default __webpack_public_path__ + "static/media/profiles.515610fd.png";